import { useCallback } from 'react'
import axios from 'axios'

import { Parking } from '@/service'

type MapInteractionType =
  | 'MAP_PARKING_DETAILS'
  | 'MAP_PARKING_QUICK_BOOKING'
  | 'MAP_PARKING_TILE_CLICK'

export const useMapTracking = () => {
  const isLocalhost =
    typeof window !== 'undefined' && window.location.hostname === 'localhost'

  const trackMapInteraction = useCallback(
    async (
      interactionType: MapInteractionType,
      parking: Parking,
      additionalData?: Record<string, any>
    ) => {
      if (isLocalhost) {
        return
      }

      try {
        const event = {
          eventType: 'click',
          objectType: 'MAP_MODAL',
          objectName: `map_${parking.urlSlug}_${interactionType}`,
          bookingData: [
            {
              parking,
              ...additionalData
            }
          ],
          timestamp: new Date().toISOString(),
          metadata: {
            pageUrl: window.location.href,
            deviceType: navigator.userAgent.includes('Mobile')
              ? 'mobile'
              : 'desktop',
            parkingId: parking.uuid,
            parkingName: parking.shortDisplayName,
            parkingCity: parking.cityUrlSlug,
            reservationAvailable: parking.reservationAvailable,
            uuid: parking.uuid,
            ...additionalData
          }
        }

        await axios.post('/api/track-events', event, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
      } catch (error) {
        console.error('Failed to track map interaction event:', error)
      }
    },
    [isLocalhost]
  )

  return {
    trackMapInteraction
  }
}
